import PageComponent from '../../common/component/page-component';

const names = {
	annotationsAttr: 'annotations',
	togglersAttr: 'togglers',
	annotationTplAttr: 'annotationTpl',
	annotationsGroupTplAttr: 'annotationsGroupTpl',
	annotationTogglerTplAttr: 'annotationTogglerTpl',
	annotationTogglersGroupTplAttr: 'annotationTogglersGroupTpl',
	connectorTplAttr: 'connectorTpl',
	annotationAttr: 'annotation',
	annotationsGroupAttr: 'annotationsGroup',
	annotationRefAttr: 'annotationRef',
	annotationContentAttr: 'annotationContent',
	togglerAttr: 'annotationToggler',
	closeTogglerAttr: 'annotationCloseToggler',
	togglersGroupAttr: 'annotationTogglersGroup',
	connectorsAttr: 'connectors',
	connectorAttr: 'connector',
	togglerNumberAttr: 'togglerNumber',
	footnoteRefAttr: 'footnoteRef',
	blockAttr: 'block',
	layoutAttr: 'layoutIndex',

	typeLink: 'link',
	typeFootnote: 'footnote',

	withSidebarVar: '--withSidebar',
	leftVar: '--left',
	topVar: '--top',

	withSidebarClass: 'withSidebar',
	showClass: 'show',
	toggledClass: 'toggled',

	otherSidebarNodesSelector: 'figcaption, cite',
};

function offsetTop(element, ref) {
	let offset = 0;
	while (element !== ref) {
		offset += element.offsetTop;
		element = element.offsetParent;
	}
	return offset;
}

function intersecting(entry, refEntries) {
	for (const refEntry of refEntries) {
		if ((entry.bottom >= refEntry.top && entry.bottom <= refEntry.bottom) || (entry.top >= refEntry.top && entry.top <= refEntry.bottom)) {
			return true;
		}
	}
	return false;
}

let footnotesNumber = 0;
const zIndexBoost = 100;

class Annotations extends PageComponent {
	prepare() {
		this.refContainer = this.element.parentNode;
		this.annotations = [];
		this.annotationTpl = this.element.querySelector(this.dataSelector(names.annotationTplAttr)).content;
		this.annotationsGroupTpl = this.element.querySelector(this.dataSelector(names.annotationsGroupTplAttr)).content;
		this.computedStyle = getComputedStyle(this.element);

		const links = this.refContainer.querySelectorAll('a[aria-description],a.footnote-ref');
		for (const link of links) {
			let annotation = null;
			if (link.matches('a[aria-description]')) {
				annotation = this.createAnnotation(names.typeLink, link);
			} else {
				const sup = link.parentNode;
				let footnoteRef = sup.previousElementSibling;
				if (footnoteRef && !footnoteRef.matches(this.dataSelector(names.footnoteRefAttr))) {
					footnoteRef = null;
				}
				annotation = this.createAnnotation(names.typeFootnote, footnoteRef, link);
			}
			if (annotation) {
				this.annotations.push(annotation);
			}
		}

		if (this.annotations.length) {
			this.currentGroup = null;
			this.currentToggler = null;
			this.currentBlock = this.element.closest(this.dataSelector(names.blockAttr));
			this.currentLayout = this.element.closest(this.dataSelector(names.layoutAttr));

			this.annotationsContainer = this.element.querySelector(this.dataSelector(names.annotationsAttr));
			this.togglersContainer = this.element.querySelector(this.dataSelector(names.togglersAttr));
			this.connectorsContainer = this.element.querySelector(this.dataSelector(names.connectorsAttr));

			this.togglerTpl = this.element.querySelector(this.dataSelector(names.annotationTogglerTplAttr)).content;
			this.togglersGroupTpl = this.element.querySelector(this.dataSelector(names.annotationTogglersGroupTplAttr)).content;
			this.connectorTpl = this.element.querySelector(this.dataSelector(names.connectorTplAttr)).content;

			this.listeners.resize = this.events.on(window, 'window:resize', this.onResize.bind(this));
			this.listeners.toggler = this.events.on(this.element, this.dataSelector(names.togglerAttr), 'click', this.onTogglerClick.bind(this));
			this.listeners.closeToggler = this.events.on(this.element, this.dataSelector(names.closeTogglerAttr), 'click', this.onCloseTogglerClick.bind(this));
			this.listeners.outClick = this.events.on(document.body, 'click', this.onOutClick.bind(this));
			requestAnimationFrame(() => this.update());
		}
	}

	onResize(event) {
		requestAnimationFrame(() => this.update());
	}

	onTogglerClick(event, target) {
		event.stopPropagation();
		console.log(this.classSelector(names.toggledClass), target, target.matches(this.classSelector(names.toggledClass)));
		if (target.matches(this.classSelector(names.toggledClass))) {
			this.closeCurrentGroup();
		} else {
			const ref = this.dataAttr(target).get(names.togglerAttr);
			const group = this.element.querySelector(this.dataSelector(names.annotationsGroupAttr, ref));
			if (group) {
				if (this.currentGroup) {
					this.closeCurrentGroup();
				}
				if (this.currentBlock) {
					this.currentBlock.style.zIndex = zIndexBoost;
				}
				if (this.currentLayout) {
					this.currentLayout.style.zIndex = zIndexBoost;
				}
				this.toggleToggler(target, true);
				this.toggleGroup(group, true);
				this.currentToggler = target;
				this.currentGroup = group;
			}
		}
	}

	onCloseTogglerClick(event, target) {
		if (this.currentGroup) {
			this.closeCurrentGroup();
		}
	}

	onOutClick(event, target) {
		if (this.currentGroup) {
			const group = target.closest(this.dataSelector(names.annotationsGroupAttr));
			if (!group || !this.element.contains(group)) {
				this.closeCurrentGroup();
			}
		}
	}

	closeCurrentGroup() {
		this.toggleToggler(this.currentToggler, false);
		this.toggleGroup(this.currentGroup, false);
		this.currentToggler = null;
		this.currentGroup = null;
		if (this.currentBlock) {
			this.currentBlock.style.removeProperty('z-index');
		}
		if (this.currentLayout) {
			this.currentLayout.style.removeProperty('z-index');
		}
	}

	toggleToggler(toggler, toggled = true) {
		this.classList(toggler).toggle(names.toggledClass, toggled);
	}

	toggleGroup(group, show = true) {
		this.classList(group).toggle(names.showClass, show);
	}

	hideGroup(group) {}

	update() {
		this.withSidebar = !!parseInt(this.computedStyle.getPropertyValue(names.withSidebarVar), 10);
		const positions = [];
		const lines = new Map();
		// first read everything, then write everything.
		// It avoids to trash the layout in a loop

		// store positions
		for (const annotation of this.annotations) {
			const refNode = annotation.refNode;
			const refNodePosition = this.getRefNodePosition(refNode);
			const position = {
				left: refNode ? refNodePosition.left : annotation.sup.offsetLeft,
				top: refNode ? refNodePosition.top : annotation.sup.offsetTop,
				annotation: annotation,
			};
			positions.push(position);
			let line = lines.get(position.top);
			if (!line) {
				line = [];
				lines.set(position.top, line);
			}
			line.push(position);
		}

		const connectorsFragment = document.createDocumentFragment();
		for (const [top, line] of lines) {
			let minLeft = null;
			for (const position of line) {
				if (position.annotation.refNode && (minLeft === null || position.left < minLeft)) {
					minLeft = position.left;
				}
			}
			if (minLeft !== null) {
				const connector = this.createConnector();
				connector.style.setProperty(names.leftVar, minLeft + 'px');
				connector.style.setProperty(names.topVar, top + 'px');
				connectorsFragment.appendChild(connector);
			}
		}

		this.classList().toggle(names.withSidebarClass, this.withSidebar);
		this.annotationsContainer.innerHTML = '';
		this.togglersContainer.innerHTML = '';
		this.connectorsContainer.innerHTML = '';
		this.currentToggler = null;
		this.currentGroup = null;

		if (this.withSidebar) {
			const opened = [];
			const annotationsFragment = document.createDocumentFragment();
			const groupsFragment = document.createDocumentFragment();
			const togglersFragment = document.createDocumentFragment();
			for (const [top, line] of lines) {
				// if there are more than one per line, they are surely closed
				if (line.length > 1) {
					const togglerGroup = this.createTogglerGroup();
					togglerGroup.style.setProperty(names.topVar, top + 'px');
					for (const position of line) {
						const annotation = position.annotation;
						const groupId = 'group_' + annotation.index;
						const group = this.createGroup(groupId);
						group.style.setProperty(names.topVar, top + 'px');
						const toggler = this.createToggler(groupId, annotation.type, annotation.number);
						togglerGroup.appendChild(toggler);
						group.appendChild(annotation.node);
						groupsFragment.appendChild(group);
					}
					togglersFragment.appendChild(togglerGroup);
					//
				} else {
					// we add the annotations in their ideal position, we will check later if they intersect with
					const annotation = line[0].annotation;
					const annotationNode = annotation.node;
					annotationNode.style.setProperty(names.topVar, top + 'px');
					annotationsFragment.appendChild(annotationNode);
					opened.push({top: top, index: annotation.index, node: annotationNode, bottom: 0, annotation: annotation});
				}
			}
			this.annotationsContainer.appendChild(annotationsFragment);
			if (opened.length) {
				const close = (entry) => {
					const togglerGroup = this.createTogglerGroup();
					togglerGroup.style.setProperty(names.topVar, entry.top + 'px');
					const groupId = 'group_' + entry.index;
					const group = this.createGroup(groupId);
					group.style.setProperty(names.topVar, entry.top + 'px');
					const toggler = this.createToggler(groupId, entry.annotation.type, entry.annotation.number);
					togglerGroup.appendChild(toggler);
					group.appendChild(entry.node);
					groupsFragment.appendChild(group);
					togglersFragment.appendChild(togglerGroup);
				};

				const remainingOpened = [];
				// we check if each annotation intersect the next one, in case we close it
				for (let i = 0; i < opened.length; i++) {
					const entry = opened[i];
					entry.bottom = entry.top + entry.node.offsetHeight;
					const nextEntry = i < opened.length - 1 ? opened[i + 1] : null;
					if (nextEntry) {
						if (entry.bottom > nextEntry.top) {
							close(entry);
						} else {
							remainingOpened.push(entry);
						}
					} else {
						remainingOpened.push(entry);
					}
				}
				if (remainingOpened.length) {
					// collect other nodes that take space in the sidebar (caption, cite)
					const otherSidebarNodes = this.refContainer.querySelectorAll(names.otherSidebarNodesSelector);
					const otherSidebarEntries = [];
					for (const node of otherSidebarNodes) {
						const top = offsetTop(node, this.refContainer);
						const entry = {
							node: node,
							top: top,
							bottom: top + node.offsetHeight,
						};
						otherSidebarEntries.push(entry);
					}
					const boxBottom = this.element.offsetHeight;
					// we check if each annotation still opened intersect with other sidebar nodes or if it overflows the end of the container
					// in case we close it;
					for (let i = 0; i < remainingOpened.length; i++) {
						const entry = remainingOpened[i];
						if (entry.bottom > boxBottom || intersecting(entry, otherSidebarEntries)) {
							close(entry);
						}
					}
				}
			}
			this.togglersContainer.appendChild(togglersFragment);
			this.annotationsContainer.appendChild(groupsFragment);
		} else {
			const groupsFragment = document.createDocumentFragment();
			const togglersFragment = document.createDocumentFragment();
			for (const [top, line] of lines) {
				const groupId = 'group_' + top;
				const group = this.createGroup(groupId);
				group.style.setProperty(names.topVar, top + 'px');

				const togglerGroup = this.createTogglerGroup();
				togglerGroup.style.setProperty(names.topVar, top + 'px');
				const toggler = this.createToggler(groupId, names.typeLink, null);
				togglerGroup.appendChild(toggler);

				for (const position of line) {
					group.appendChild(position.annotation.node);
				}
				groupsFragment.appendChild(group);
				togglersFragment.appendChild(togglerGroup);
			}
			this.togglersContainer.appendChild(togglersFragment);
			this.annotationsContainer.appendChild(groupsFragment);
		}
		this.connectorsContainer.appendChild(connectorsFragment);
	}

	getRefNodePosition(refNode) {
		if (!refNode) {
			return null;
		}
		let node = refNode;
		let left = 0;
		let top = 0;
		do {
			left += node.offsetLeft;
			top += node.offsetTop;
			node = node.offsetParent;
		} while (node !== null && node !== this.refContainer);
		return {
			left: left,
			top: top,
		};
	}

	createGroup(id) {
		const fragment = this.annotationsGroupTpl.cloneNode(true);
		const node = fragment.querySelector(this.dataSelector(names.annotationsGroupAttr));
		this.dataAttr(node).set(names.annotationsGroupAttr, id);
		return node;
	}

	createTogglerGroup() {
		const fragment = this.togglersGroupTpl.cloneNode(true);
		const node = fragment.querySelector(this.dataSelector(names.togglersGroupAttr));
		return node;
	}

	createToggler(id, type, number = null) {
		const fragment = this.togglerTpl.cloneNode(true);
		const node = fragment.querySelector(this.dataSelector(names.togglerAttr));
		this.classList(node).add(type);
		this.dataAttr(node).set(names.togglerAttr, id);
		if (number !== null) {
			node.querySelector(this.dataSelector(names.togglerNumberAttr)).textContent = number;
		}
		return node;
	}

	createConnector() {
		const fragment = this.connectorTpl.cloneNode(true);
		const node = fragment.querySelector(this.dataSelector(names.connectorAttr));
		return node;
	}

	createAnnotation(type, refNode, footnoteLink = null) {
		const annotation = {
			type: type,
			index: this.annotations.length,
			refNode: refNode,
			node: null,
			number: null,
			sup: null,
		};
		const fragment = this.annotationTpl.cloneNode(true);
		const node = fragment.querySelector(this.dataSelector(names.annotationAttr));
		this.classList(node).add(type);
		const ref = node.querySelector(this.dataSelector(names.annotationRefAttr));
		const content = node.querySelector(this.dataSelector(names.annotationContentAttr));
		if (type === names.typeLink) {
			const link = document.createElement('a');
			for (const attribute of refNode.attributes) {
				if (attribute.name !== 'aria-description') {
					link.setAttribute(attribute.name, attribute.value);
				}
			}
			link.textContent = refNode.textContent;
			ref.appendChild(link);
			content.textContent = refNode.getAttribute('aria-description');
		} else {
			annotation.sup = footnoteLink.parentNode;
			footnotesNumber++;
			const number = footnotesNumber;
			if (!refNode) {
				const newSup = document.createElement('sup');
				newSup.textContent = number;
				annotation.sup.parentNode.insertBefore(newSup, annotation.sup);
			}
			footnoteLink.textContent = number;

			annotation.number = number;
			ref.textContent = number;
			const footnoteContentNode = this.refContainer.querySelector('[id="' + footnoteLink.getAttribute('href').substring(1) + '"]');
			if (footnoteContentNode) {
				const backLink = footnoteContentNode.querySelector('.footnote-backref');
				if (backLink) {
					backLink.parentNode.removeChild(backLink);
				}
				content.innerHTML = footnoteContentNode.innerHTML;
			}
			// content.textContent = refNode.getAttribute('aria-description');
		}
		annotation.node = node;
		return annotation;
	}
}

export default Annotations;
